
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-swatch-filter',
})
export default class extends Vue {
  @Prop() readonly dataSource: string;
  @Prop() readonly filter!: object;

  readonly filtersToShow: number = 8;
  private filterCollapsed: boolean = this.filter['options'].length > this.filtersToShow;
  private filterOpen: boolean = !!!this.$mobileDetect.mobile();

  private toggleFilterValueCollapse(): void {
    this.filterCollapsed = !this.filterCollapsed;
  }

  private filterIsVisibleCheck(index): boolean {
    return this.filterCollapsed ? index < this.filtersToShow : true;
  }

  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

  private isLight(color): boolean {
    let r, g, b, hsp;
    if (color.match(/^rgb/)) {
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }

    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    return hsp > 127.5;
  }
}
